import { shouldMockEndpoints } from './functions';

interface Params<TParams extends any[], TResult> {
  main(...params: TParams): TResult;
  mock(...params: TParams): TResult;
}

/**
 * Takes two functions, a primary and mock function.
 *
 * This function will call the mock version if certain env variables are set
 */
export const createMockableFunction = <TParams extends any[], TResult = any>({
  main,
  mock,
}: Params<TParams, TResult>): ((...params: TParams) => TResult) => {
  if (shouldMockEndpoints()) {
    return mock;
  } else {
    return main;
  }
};
